import type { QuotaCleanerGroup } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import type { UserQuotaGroupId } from 'reactApp/types/QuotaCleaner';

/**
 * @param groups Все группы чистилки
 * @param groupIdsByPiority Id групп чистилки в порядке приоритета быстрой очистки
 * @param overquotaBytes Сколько надо очистить байт
 * @returns
 */
export const getFastCleanInfo = (
    cleanerGroups: QuotaCleanerGroup[],
    groupIdsByPiority: UserQuotaGroupId[],
    overquotaBytes: number
): QuotaCleanerGroup[] => {
    if (overquotaBytes <= 0) {
        return [];
    }

    // функция используется в редюсере – спасаемся от мутации стейта
    const groups = cleanerGroups.map((group) => ({ ...group }));

    const groupIdPriorityIndexMap = groupIdsByPiority.reduce(function (map, groupId, priorityIndex) {
        map[groupId] = priorityIndex;
        return map;
    }, {});

    const groupsByPriority = groups
        .filter((group) => group.size_uniq !== 0 && group.groupId in groupIdPriorityIndexMap)
        .sort((group1, group2) => {
            return groupIdPriorityIndexMap[group1.groupId] - groupIdPriorityIndexMap[group2.groupId];
        });

    let remainingOverquotaBytes = overquotaBytes;
    const fastCleanGroups: QuotaCleanerGroup[] = [];
    for (const group of groupsByPriority) {
        if (remainingOverquotaBytes <= 0) {
            break;
        }

        fastCleanGroups.push(group);
        remainingOverquotaBytes -= group.size_uniq;
    }

    if (remainingOverquotaBytes > 0) {
        return [];
    }

    // для последней категории в size записываем, сколько реально надо почистить
    fastCleanGroups[fastCleanGroups.length - 1].size_uniq += remainingOverquotaBytes;

    return fastCleanGroups;
};
